import { useMutation } from '@tanstack/react-query';

import { api } from 'api/v1';

export type PasswordResetResponse = {
  status?: string;
  message?: string;
  email_sent?: boolean;
  email?: string;
  phone_otp_required?: boolean;
  challenge_id?: string;
  channel?: string;
};

export const useResetRequestMutation = () => {
  return useMutation<PasswordResetResponse, Error, string>({
    mutationFn: (login) =>
      api
        .post(
          '/password/reset-request',
          { login },
          { skipAuthRefresh: true, skipGlobalErrorHandler: true },
        )
        .then((res) => res.data),
  });
};

export const useResetConfirmMutation = () => {
  return useMutation<
    { message?: string },
    Error,
    { token: string; new_password: string; repeat_new_password: string }
  >({
    mutationFn: (data) =>
      api
        .post('/password/reset-confirm', data, {
          skipAuthRefresh: true,
          skipGlobalErrorHandler: true,
        })
        .then((res) => res.data),
  });
};
